<template>
  <div>
    <nav data-cy="settings-nav">
      <div
        class="navbar-secondary navbar-items tw-whitespace-no-wrap tw-bg-blue-250 tw-rounded-lg tw-mx-4"
      >
        <div>
          <span
            class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-pb-3 tw-pt-4 tw-flex tw-text-gray-700 tw-text-lg"
            >REPORTS</span
          >
        </div>
        <RouterLink
          :to="{ name: 'reports-employee' }"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-text-gray-770 tw-font-medium tw-text-xl hover:tw-bg-blue-400 tw-rounded-lg"
          data-cy="employee-report"
        >
          <SvgIcon
            name="employee-icon-alt"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-770"
          />
          <span>Employees</span>
        </RouterLink>
        <RouterLink
          :to="{ name: 'reports-leave' }"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-text-gray-770 tw-font-medium tw-text-xl hover:tw-bg-blue-400 tw-rounded-lg"
          data-cy="leave-report"
        >
          <SvgIcon
            name="leave-icon-alt"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-770"
          />
          <span>Leave</span>
        </RouterLink>
        <RouterLink
          :to="{ name: 'reports-allowances' }"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-text-gray-770 tw-font-medium tw-text-xl hover:tw-bg-blue-400 tw-rounded-lg"
          data-cy="allowance-report"
        >
          <SvgIcon
            name="allowance-icon-alt"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-770"
          />
          <span>Allowances</span>
        </RouterLink>
        <RouterLink
          v-if="isOvertimeEnabled && companyHasToilFeature"
          :to="{ name: 'reports-overtime' }"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-text-gray-770 tw-font-medium tw-text-xl hover:tw-bg-blue-400 tw-rounded-lg"
          data-cy="toil-report"
        >
          <SvgIcon
            name="overtime-icon-alt"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-770"
          />
          <span>Overtime</span>
        </RouterLink>
        <RouterLink
          :to="{ name: 'reports-employment-holidays' }"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-text-gray-770 tw-font-medium tw-text-xl hover:tw-bg-blue-400 tw-rounded-lg"
          data-cy="public-holiday-report"
        >
          <SvgIcon
            name="holiday-icon-alt"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-770"
          />
          <span>Public Holidays</span>
        </RouterLink>
        <RouterLink
          :to="{ name: 'reports-approver' }"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-3 tw-py-3 tw-flex tw-items-center tw-text-gray-770 tw-font-medium tw-text-xl hover:tw-bg-blue-400 tw-rounded-lg"
          data-cy="approvers-report"
        >
          <SvgIcon
            name="approver-icon-alt"
            class="tw-mr-2 tw-w-5 tw-h-5 tw-text-gray-770"
          />
          <span>Approver</span>
        </RouterLink>
      </div>
    </nav>
  </div>
</template>

<script>
import Feature from '@/models/Billing/Feature'

export default {
  name: 'ReportsNavbar',

  computed: {
    isOvertimeEnabled() {
      return !!this.activeCompany.current_time_off_in_lieu
    },

    companyHasToilFeature() {
      return this.activeCompany.planHasFeature(Feature.TimeOffInLieu)
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar-secondary {
  @screen lg {
    @apply .w-auto;
  }
}
</style>
